import securedAxios from '~/javascript/utils/axios'

const axios = securedAxios()

export function startCompetitorAnalysis(pageId, competitorUrls = []) {
  return axios.post(`/ajax/website_pages/${pageId}/start_competitor_analysis`, { competitor_urls: competitorUrls })
}

export function getCompetitorAnalysis(pageId) {
  return axios.get(`/ajax/website_pages/${pageId}/competitor_analysis`)
}

export function verifyCompetitor(competitorId, status, correctedContent = null) {
  return axios.post(`/ajax/competitor_pages/${competitorId}/verify`, { status, corrected_content: correctedContent })
}

export function runForensicAudit(pageId) {
  return axios.post(`/ajax/website_pages/${pageId}/run_forensic_audit`)
}

export function approveQualityProfile(pageId, tierAdjustments = {}) {
  return axios.post(`/ajax/website_pages/${pageId}/approve_quality_profile`, { tier_adjustments: tierAdjustments })
}
